import { cn } from "@omni/utils/styles";
import { Fragment } from "react";

import { AdditionalServiceComponent } from "@/components/Product/AdditionalService/additionalService.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { CartItemPrice } from "../../price/cartItemPrice.component";

export type CartAdditionalService = {
    sku: string;
    title: string;
    unitPrice?: number;
    totalPrice?: number;
    cartItemId?: string;
    isSelected: boolean;
    childAdditionalService: boolean;
    additionalServiceAllowed: boolean;
};

type AdditionalServicesProps = {
    cartItemId: string;
    additionalServices: Array<CartAdditionalService>;
    onRemoveAdditionalService: (serviceCartItemId: string) => void;
    onAddAdditionalService: (cartItemId: string, serviceSku: string) => void;
};

const AdditionalServices = ({
    additionalServices,
    cartItemId,
    onAddAdditionalService,
    onRemoveAdditionalService
}: AdditionalServicesProps) => {
    const { t } = useGranite();

    const handleOnServiceProductClick = (
        isSelected: boolean,
        serviceSku: string,
        serviceCartItemId?: string
    ) => {
        if (isSelected && serviceCartItemId) {
            onRemoveAdditionalService(serviceCartItemId);
        } else {
            onAddAdditionalService(cartItemId, serviceSku);
        }
    };

    if (additionalServices.length === 0) {
        return null;
    }

    return (
        <div className={cn("tw:flex tw:mt-2 tw:flex-wrap")}>
            {additionalServices.map((service, index) => (
                <Fragment key={index}>
                    {!service.additionalServiceAllowed &&
                        !service.isSelected && (
                            <p
                                className={cn(
                                    "tw:text-neutral-400 tw:m-0 tw:w-full"
                                )}
                            >
                                {t(
                                    "general.cartItem.serviceProduct.additionalServiceNotAllowed"
                                )}
                            </p>
                        )}
                    <div
                        className={cn(
                            "tw:flex tw:flex-col tw:md:flex-row tw:grow tw:justify-between tw:ml-5"
                        )}
                    >
                        <AdditionalServiceComponent
                            key={`${service.sku}-${index}`}
                            additionalService={{
                                sku: service.sku,
                                price: service.unitPrice,
                                title: service.title
                            }}
                            onClick={() =>
                                handleOnServiceProductClick(
                                    service.isSelected,
                                    service.sku,
                                    service.cartItemId
                                )
                            }
                            isSelected={service.isSelected}
                            type={"checkbox"}
                            removable={!service.childAdditionalService}
                            addable={service.additionalServiceAllowed}
                            showPrice={true}
                        />
                        {service.isSelected && (
                            <div
                                className={cn(
                                    "tw:text-right tw:flex tw:flex-col tw:justify-center tw:pl-0"
                                )}
                            >
                                <CartItemPrice
                                    totalPrice={service.totalPrice}
                                />
                            </div>
                        )}
                    </div>
                </Fragment>
            ))}
        </div>
    );
};

export default AdditionalServices;
